import React from 'react';
import PropTypes from 'prop-types';
import { Input, Select, Button, Tooltip } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new';
import { getMatchOption } from '../../../shared/selectFn';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';

const { Option } = Select;

export default function Filter(props, context) {
    const {
        searchParams, 
        area, 
        business, 
        onSearch, 
        onExport, 
        onChange,
        onReset, 
        showUpdate,
        verifyAgencyList=[]
    } = props;
    
    const handleChange = (value, key) => {
        switch (key) {
            case 'investigation':
            case 'hospital':
            case 'disease':
            case 'pm':
            case 'pml': 
            case 'areaLeader':
            {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                break;
            }
            case 'investigationAreaId':
                searchParams[key] = value;
                searchParams.diseaseId = undefined;
                searchParams.diseaseName = undefined;
                break;
            case 'lineOfBusiness':
                searchParams[key] = value;
                searchParams.secondLineName = undefined;
                break;
            default: {
                searchParams[key] = value;
                break;
            }
        }
        onChange(searchParams);
    };

    const { childList } = getMatchOption(business, 'typeConfigureId', searchParams.lineOfBusiness);
    const verifyAgencyOption = verifyAgencyList.map(i => <Option key={i.verifyAgencyId} value={i.verifyAgencyId}>
        {/* {i.agencyName} */}
            <Tooltip placement="right" title={i.agencyName}>
                <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{i.agencyName}</span>
            </Tooltip>
        </Option>);
    const businessOption = business.map(i => <Option key={i.typeConfigureId}>{i.typeValue}</Option>);
    const secondLineOption = (childList || []).map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
    const areaOption = area.map(i => <Option key={i.investigationAreaId}>{i.investigationAreaName}</Option>);

    return (
        <div className="search-bar" style={{ marginBottom: 16 }}>
           <div className="search-item">
                <label className="ui-label">国家核查编号</label>
                <Input
                    placeholder="请输入"
                    style={{width: 150}}
                    value={searchParams.nationVerifyNumber}
                    onChange={e => handleChange(e.target.value, 'nationVerifyNumber')}
                />
            </div>
            <div className="search-item">
                <label className="ui-label">核查机构</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 150}}
                    value={searchParams.verifyAgencyId}
                    onChange={value => handleChange(value, 'verifyAgencyId')}
                >
                    {verifyAgencyOption}
                </Select>
            </div>
            <div className="search-item">
                <label className="ui-label">项目简称</label>
                <SearchRetrieve
                    keyword='investigationName'
                    style={{ width: 160 }}
                    params={{ limit: 20 , isHistory: 'FALSE' }}
                    placeholder="输入名称检索"
                    value={searchParams.investigationName}
                    url={API_URL.investigation.queryInvestigationByName}
                    config={{ id: 'investigationId', name: 'investigationName' }}
                    onChange={option => handleChange(option, 'investigation')}
                />
            </div>
            <div className="search-item">
                <label className="ui-label">被核查研究中心</label>
                <SearchRetrieve
                    keyword='hospitalName'
                    style={{ width: 160 }}
                    params={{ limit: 20 }}
                    placeholder="输入中心名称检索"
                    value={searchParams.hospitalName}
                    url={API_URL.hospital.list}
                    config={{ id: 'hospitalId', name: 'hospitalName' }}
                    onChange={option => handleChange(option, 'hospital')}
                />
            </div>
            <div className="search-item">
                <label htmlFor="" className="ui-label">PM</label>
                <SearchRetrieve
                    keyword='keyword'
                    style={{ width: 140 }}
                    placeholder="输入姓名/工号检索"
                    value={searchParams.pmName}
                    params={{ limit: 20 }}
                    url={API_URL.investigation.queryUserByKey}
                    config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                    onChange={value => handleChange(value, 'pm')}
                />
            </div>
            <div className="search-item">
                <label htmlFor="" className="ui-label">PML</label>
                <SearchRetrieve
                    keyword='keyword'
                    style={{ width: 140 }}
                    placeholder="输入姓名/工号检索"
                    value={searchParams.pmlName}
                    params={{ limit: 20 }}
                    url={API_URL.investigation.queryUserByKey}
                    config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                    onChange={value => handleChange(value, 'pml')}
                />
            </div>
            <div className="search-item">
                <label htmlFor="" className="ui-label">领域leader</label>
                <SearchRetrieve
                    keyword='leaderName'
                    style={{ width: 140 }}
                    placeholder="输入姓名/工号检索"
                    value={searchParams.areaLeaderName}
                    params={{ limit: 20 }}
                    url={API_URL.nationalverification.queryLeaderListForSearch}
                    config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                    onChange={value => handleChange(value, 'areaLeader')}
                />
            </div>
            <div className="search-item">
                <label htmlFor="" className="ui-label">项目领域</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{ width: 100 }}
                    value={searchParams.investigationAreaId}
                    onChange={value => handleChange(value, 'investigationAreaId')}
                >
                    {areaOption}
                </Select>
            </div>
            <div className="search-item">
                <label className="ui-label">疾病</label>
                <SearchRetrieve
                    keyword='keyword'
                    style={{ width: 140 }}
                    params={{ investigationAreaId: searchParams.investigationAreaId }}
                    placeholder="输入名称检索"
                    url={API_URL.common.queryAllDisease}
                    value={searchParams.diseaseName}
                    config={{ id: 'diseaseId', name: 'diseaseName' }}
                    onChange={(option) => handleChange(option, 'disease')}
                />
            </div>
            <div className="search-item">
                <label htmlFor="" className="ui-label">业务线</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 100}}
                    value={searchParams.lineOfBusiness}
                    onChange={value => handleChange(value, 'lineOfBusiness')}
                >
                    {businessOption}
                </Select>
            </div>
            <div className="search-item">
                <label htmlFor="" className="ui-label">执行业务线二级分类</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 140}}
                    disabled={!searchParams.lineOfBusiness}
                    value={searchParams.secondLineId}
                    onChange={value => handleChange(value, 'secondLineId')}
                >
                    {secondLineOption}
                </Select>
            </div>
            <div className="search-item">
                <Button type="primary" onClick={onSearch}>搜索</Button>
                <Button type="primary" onClick={onReset}>重置</Button>
                <Button type="primary" onClick={onExport}>导出</Button>
                <Button type="primary" onClick={() => showUpdate('add', {})}>添加</Button>
            </div>
        </div>
    );
}

Filter.contextTypes = {
    configure: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/qualityManagement/Nationalverification/components/Filter.js